import { z } from "zod";
import { IsoDateTime, jsonColumn } from "./common.ts";

export const ActionLogSchema = z.object({
  id: z.number().int(),
  created_at: IsoDateTime,
  kind: z.string(),
  label: z.string(),
  forward: jsonColumn(z.unknown()),
  inverse: jsonColumn(z.unknown()),
  undone_at: IsoDateTime.nullable(),
});

export type ActionLog = z.infer<typeof ActionLogSchema>;

export const UndoStatusSchema = z.object({
  can_undo: z.boolean(),
  can_redo: z.boolean(),
  next_label: z.string().nullable(),
  redo_label: z.string().nullable(),
});

export type UndoStatus = z.infer<typeof UndoStatusSchema>;
